import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

type DocType = "TERMS" | "PRIVACY";
type Locale = "pl" | "en";

type StaticDoc = {
    title: string;
    version?: string;
    publishedAt?: string; // ISO
    text: string;
};

/**
 * PEŁNA POLSKA POLITYKA PRYWATNOŚCI – bazuje na Twojej wersji plain text
 */
const PRIVACY_PL_TEXT = `Polityka prywatności aplikacji mobilnej „Polylect”

1. Informacje ogólne

1.1. Niniejsza Polityka prywatności wyjaśnia zasady przetwarzania danych osobowych Użytkowników aplikacji „Polylect”.
1.2. Administratorem danych osobowych jest Michał Pacierz.
Dane kontaktowe:
- adres e-mail: mpacierz@polylect.pl

1.3. W sprawach związanych z ochroną danych osobowych możesz skontaktować się z Administratorem pod powyższym adresem e-mail.

1.4. Dane osobowe przetwarzane są zgodnie z obowiązującymi przepisami, w szczególności Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 („RODO”).

2. Zakres przetwarzanych danych

W zależności od sposobu korzystania z Aplikacji, możemy przetwarzać następujące kategorie danych:

2.1. Dane Gościa (bez Konta)
- dane techniczne urządzenia (np. model urządzenia, system operacyjny, identyfikator Aplikacji),
- anonimowe dane dotyczące korzystania z Aplikacji (np. otwierane ekrany, czas korzystania) – jeśli włączone są odpowiednie mechanizmy statystyczne,
- dane zawarte w zgłoszeniach błędów (np. opis problemu, ewentualnie zrzuty ekranu, jeżeli Użytkownik je prześle).

2.2. Dane Użytkownika z Kontem
- adres e-mail (login do Konta lub adres przypisany do logowania Google),
- nazwa profilu (ustawiona przez Użytkownika),
- data urodzenia (w podanym przez Użytkownika zakresie),
- dane statystyczne dotyczące korzystania z Aplikacji (np. liczba przeczytanych tekstów, wyniki quizów, listy słówek),
- dane o urządzeniach przypisanych do Konta (w celu weryfikacji limitu sesji).

2.3. Dane Użytkownika Premium
- informacje o statusie Subskrypcji Premium (np. typ subskrypcji, okres obowiązywania),
- identyfikatory wymagane do obsługi Subskrypcji przekazywane między Aplikacją, sklepem (Apple/Google) i usługą pośredniczącą,
- dane niezbędne do obsługi funkcji „przywróć zakup”.
Administrator nie otrzymuje pełnych danych dotyczących Twojej karty płatniczej ani szczegółowych informacji płatniczych – obsługują je sklepy (Apple/Google) oraz ich operatorzy płatności.

2.4. Dane dotyczące komunikacji i newslettera
- adres e-mail i treść wiadomości w przypadku kontaktu na support@polylect.pl lub poprzez formularz w Aplikacji,
- informacje o zgodach na otrzymywanie wiadomości marketingowych lub newslettera,
- dane niezbędne do wysyłki wiadomości systemowych (np. reset hasła, istotne komunikaty).

3. Cele i podstawy prawne przetwarzania danych

Dane osobowe przetwarzamy w następujących celach i na następujących podstawach prawnych:

3.1. Korzystanie z Aplikacji i realizacja usług
(art. 6 ust. 1 lit. b RODO – niezbędność do wykonania umowy)
- założenie i obsługa Konta Użytkownika,
- umożliwienie logowania (w tym logowania Google),
- udostępnienie Treści, statystyk, list słówek, quizów i innych funkcji Aplikacji,
- obsługa Subskrypcji Premium w zakresie niezbędnym po stronie Aplikacji.

3.2. Obsługa płatności i Subskrypcji Premium
(art. 6 ust. 1 lit. b i f RODO – wykonanie umowy i prawnie uzasadniony interes)
- weryfikacja statusu Subskrypcji Premium,
- obsługa promocji i kodów promocyjnych,
- weryfikacja ważności Premium na różnych urządzeniach.

3.3. Wysyłanie powiadomień systemowych i kontakt z Użytkownikiem
(art. 6 ust. 1 lit. b i f RODO)
- reset hasła, istotne zmiany w Regulaminie lub Polityce,
- odpowiedzi na zgłoszenia błędów i reklamacje.

3.4. Marketing własnych usług (newsletter, treści promocyjne)
(art. 6 ust. 1 lit. a RODO – zgoda)
- wysyłka newslettera i informacji promocyjnych na adres e-mail,
- powiadomienia push o charakterze marketingowym (jeśli Użytkownik wyrazi zgodę).

3.5. Statystyka, ulepszanie Aplikacji i bezpieczeństwo
(art. 6 ust. 1 lit. f RODO – prawnie uzasadniony interes)
- analiza sposobu korzystania z Aplikacji (w formie zanonimizowanej lub pseudonimizowanej, jeśli to możliwe),
- dostosowywanie Treści i poziomu nauki (m.in. na podstawie wieku lub wyników quizów),
- monitorowanie stabilności Aplikacji i zapobieganie nadużyciom (np. próby ataków, nadmierne obciążanie serwera).

4. Odbiorcy danych

4.1. Dane Użytkowników mogą być przekazywane następującym kategoriom odbiorców:
- dostawcy usług hostingu i serwerów (przechowywanie danych),
- dostawcy usług obsługi subskrypcji i rozliczeń (np. sklepy Apple App Store, Google Play oraz usługodawca pośredniczący w obsłudze subskrypcji),
- dostawcy usług logowania zewnętrznego (np. Google – w przypadku logowania przez konto Google),
- dostawcy narzędzi do wysyłki wiadomości e-mail lub powiadomień,
- dostawcy narzędzi analitycznych lub statystycznych (jeśli są używane),
- organy publiczne, jeśli wynika to z przepisów prawa.

4.2. Dane nie są sprzedawane innym podmiotom w celu prowadzenia przez nie marketingu własnych usług.

4.3. Część danych może być przetwarzana poza Europejskim Obszarem Gospodarczym (np. przez globalne usługi IT). W takich przypadkach Administrator zapewni stosowanie odpowiednich zabezpieczeń prawnych, np. standardowych klauzul umownych.

5. Okres przechowywania danych

5.1. Dane powiązane z Kontem Użytkownika przechowywane są przez okres istnienia Konta, a następnie przez okres niezbędny do rozpatrzenia ewentualnych roszczeń (co do zasady nie dłużej niż 6 lat, jeśli przepisy nie wymagają dłuższego okresu).

5.2. Dane Gościa przechowywane lokalnie na urządzeniu mogą być usunięte w razie odinstalowania Aplikacji lub wyczyszczenia danych Aplikacji.

5.3. Dane przetwarzane na podstawie zgody (np. marketing) są przechowywane do czasu wycofania zgody lub zaniechania wysyłki newslettera, a następnie przez okres niezbędny do celów dowodowych (nie dłużej niż 3 lata od wycofania zgody).

5.4. Dane z logów technicznych i statystyk mogą być przechowywane przez okres potrzebny do zapewnienia bezpieczeństwa i poprawy działania Aplikacji.

6. Prawa Użytkownika

Masz prawo do:
- dostępu do swoich danych osobowych,
- sprostowania danych (jeśli są nieprawidłowe),
- usunięcia danych,
- ograniczenia przetwarzania,
- przenoszenia danych (jeśli technicznie możliwe),
- sprzeciwu wobec przetwarzania danych opartego na prawnie uzasadnionym interesie,
- wycofania zgody w dowolnym momencie (w zakresie, w jakim przetwarzanie odbywa się na podstawie zgody).

Aby skorzystać z powyższych praw, skontaktuj się z Administratorem na adres: support@polylect.pl.

Masz także prawo wnieść skargę do właściwego organu nadzorczego (Prezesa Urzędu Ochrony Danych Osobowych w Polsce), jeśli uznasz, że przetwarzanie Twoich danych narusza przepisy RODO.

7. Usuwanie Konta i danych

7.1. Użytkownik może usunąć Konto za pomocą odpowiedniej funkcji dostępnej w Aplikacji. Usunięcie Konta powoduje usunięcie danych powiązanych z Kontem w systemie Aplikacji, z zastrzeżeniem danych, które muszą być przechowywane dłużej ze względu na przepisy prawa (np. dane niezbędne do rozliczeń).

7.2. Usunięcie Konta nie powoduje automatycznego anulowania Subskrypcji Premium w sklepie. Użytkownik musi samodzielnie zarządzać Subskrypcją w ustawieniach Apple App Store lub Google Play.

8. Pliki i identyfikatory techniczne

8.1. Aplikacja może wykorzystywać lokalne pliki/identyfikatory techniczne (odpowiedniki plików cookies w środowisku aplikacji mobilnych) w celu:
- utrzymania sesji Użytkownika,
- zapamiętania preferencji,
- prowadzenia anonimowych statystyk korzystania z Aplikacji,
- obsługi funkcji offline.

8.2. W ustawieniach urządzenia Użytkownik może ograniczyć niektóre formy śledzenia lub udostępniania identyfikatorów reklamowych, co może wpływać na sposób działania niektórych funkcji Aplikacji.

9. Bezpieczeństwo danych

9.1. Administrator stosuje odpowiednie środki techniczne i organizacyjne, mające na celu ochronę danych osobowych przed nieuprawnionym dostępem, utratą, zmianą czy zniszczeniem.

9.2. Dostęp do danych mają wyłącznie osoby upoważnione i tylko w zakresie niezbędnym do wykonywania powierzonych im zadań.

10. Zmiany Polityki prywatności

10.1. Polityka może być okresowo aktualizowana, w szczególności w przypadku zmian w przepisach prawa, funkcjonalności Aplikacji lub zastosowanych technologii.

10.2. O istotnych zmianach Polityki Użytkownicy zostaną poinformowani poprzez komunikat w Aplikacji oraz – w miarę możliwości – drogą e-mail. Dalsze korzystanie z Aplikacji po wejściu w życie zmian oznacza akceptację nowej Polityki.
`;

/**
 * PEŁNY POLSKI REGULAMIN – bazuje na Twojej wersji plain text
 */
const TERMS_PL_TEXT = `Regulamin korzystania z aplikacji mobilnej „Polylect”

1. Postanowienia ogólne

1.1. Niniejszy regulamin określa zasady korzystania z aplikacji mobilnej „Polylect”, dostępnej w sklepach Apple App Store i Google Play.
1.2. Właścicielem i administratorem aplikacji jest Michał Pacierz, prowadzący działalność jako osoba prywatna.
Dane kontaktowe:
- adres e-mail: mpacierz@polylect.pl
1.3. Akceptacja Regulaminu jest dobrowolna, ale konieczna do korzystania z aplikacji. Brak akceptacji Regulaminu uniemożliwia korzystanie z aplikacji.
1.4. Aktualna wersja regulaminu jest zawsze dostępna w ustawieniach aplikacji. W przypadku zmian regulaminu użytkownik zostanie poproszony o ponowną akceptację. Brak akceptacji nowej wersji oznacza brak możliwości dalszego korzystania z aplikacji.

2. Definicje

2.1. Użytkownik – osoba fizyczna korzystająca z aplikacji (w trybie gościa lub na utworzonym koncie).
2.2. Gość – Użytkownik korzystający z aplikacji bez rejestracji Konta.
2.3. Konto – indywidualny panel Użytkownika, tworzony w wyniku rejestracji (także poprzez logowanie za pośrednictwem konta Google), umożliwiający korzystanie z dodatkowych funkcji Aplikacji.
2.4. Użytkownik Premium – Użytkownik posiadający aktywną subskrypcję premium wykupioną za pośrednictwem sklepu Apple App Store lub Google Play.
2.5. Subskrypcja Premium – płatny dostęp do dodatkowych treści i funkcji Aplikacji na okres (miesiąca, pół roku lub roku), zgodnie z ofertą prezentowaną w Aplikacji i w sklepach z aplikacjami.
2.6. Treści – teksty, tłumaczenia, quizy, materiały audio i inne materiały dostępne w Aplikacji.

3. Zakres i charakter usług

3.1. Aplikacja jest aplikacją językową umożliwiającą m.in.:
- dostęp do tekstów w różnych językach (m.in. angielski, niemiecki, hiszpański, włoski, francuski, ukraiński) wraz z tłumaczeniami,
- odtwarzanie wybranych treści audio (lektora),
- korzystanie z quizów językowych,
- tworzenie list słówek (dla Użytkowników z Kontem),
- przeglądanie statystyk nauki (dla Użytkowników z Kontem).
3.2. Aplikacja jest darmowa do pobrania. Część Treści jest dostępna bezpłatnie, natomiast dostęp do większości Treści możliwy jest wyłącznie w ramach Subskrypcji Premium.
3.3. Treści w Aplikacji są generowane i tłumaczone maszynowo, a następnie weryfikowane pod kątem:
- braku treści przemocowych,
- braku treści seksualnych,
- braku innych treści powszechnie uznawanych za nieodpowiednie.
3.4. Pomimo weryfikacji, Treści oraz tłumaczenia mogą zawierać błędy językowe, merytoryczne lub kontekstowe. Aplikacja ma charakter edukacyjno-poglądowy i nie może być traktowana jako profesjonalne źródło tłumaczeń lub porad.

4. Tryby korzystania z Aplikacji

4.1. Tryb Gościa

4.1.1. Użytkownik może korzystać z Aplikacji jako Gość po zaakceptowaniu Regulaminu i Polityki prywatności.
4.1.2. W trybie Gościa dostępne są m.in.:
- przeglądanie wybranych darmowych Treści,
- odtwarzanie audio dla dostępnych tekstów,
- tłumaczenie słówek przy użyciu Google Translate (poprzez dłuższe przytrzymanie słowa – gdzie funkcja jest dostępna),
- możliwość zgłaszania błędów w Treściach i działaniach Aplikacji.
4.1.3. W trybie Gościa nie są dostępne:
- statystyki nauki,
- historia przeglądania Treści,
- tworzenie i przechowywanie list słówek,
- Subskrypcja Premium (zakup premium wymaga założenia Konta).
4.1.4. Dane związane z korzystaniem w trybie Gościa są przechowywane lokalnie na urządzeniu, a w razie zmiany urządzenia lub reinstalacji Aplikacji mogą zostać utracone.

4.2. Użytkownik z Kontem (bez Premium)

4.2.1. Użytkownik może utworzyć Konto:
- poprzez klasyczny formularz rejestracyjny (login/hasło),
- poprzez logowanie za pośrednictwem konta Google (tzw. social login).
4.2.2. Po utworzeniu Konta Użytkownik może:
- korzystać z darmowych Treści,
- tworzyć listy słówek,
- oznaczać Treści jako „ulubione” lub „polubione”,
- korzystać z podstawowych statystyk nauki,
- wprowadzać kody promocyjne odblokowujące Premium na określony czas (np. miesiąc),
- zgłaszać błędy w Treściach i działaniu Aplikacji.
4.2.3. Użytkownik może dowolnie ustawić nazwę profilu, przy czym nazwy nie mogą mieć charakteru obraźliwego, wulgarnego, nawołującego do nienawiści lub w inny sposób naruszającego prawo lub dobre obyczaje.
4.2.4. Użytkownik podaje datę urodzenia wyłącznie w celach statystycznych oraz dopasowania poziomu i charakteru przyszłych treści.

4.3. Użytkownik Premium

4.3.1. Użytkownik posiadający Konto może wykupić Subskrypcję Premium na dostępne okresy (np. miesiąc, pół roku, rok), zgodnie z cenami prezentowanymi w Aplikacji.
4.3.2. Zakupu Subskrypcji Premium dokonuje się za pośrednictwem sklepu:
- Apple App Store (dla urządzeń Apple),
- Google Play (dla urządzeń z systemem Android).
Rozliczenia, płatności, zwroty i reklamacje płatności odbywają się zgodnie z regulaminami odpowiednich sklepów.
4.3.3. Subskrypcja Premium daje prawo do:
- dostępu do wszystkich Treści oznaczonych jako premium (również dodawanych w przyszłości),
- zapisywania Treści do odczytu offline, z zastrzeżeniem konieczności okresowej weryfikacji dostępu przez Aplikację (wymagane połączenie z Internetem co pewien czas).
4.3.4. Dodatkowe funkcje, takie jak:
- odtwarzanie audio (lektora),
- tłumaczenie słówek poprzez Google Translate,
są funkcjami dodatkowymi/pomocniczymi i ich pełne oraz nieprzerwane działanie nie jest gwarantowane. Ewentualne przejściowe problemy z ich działaniem nie stanowią podstawy do roszczeń wobec Operatora poza zakresem wynikającym z bezwzględnie obowiązujących przepisów prawa.
4.3.5. Użytkownik może próbować przywrócić zakup Subskrypcji Premium za pomocą funkcji „Przywróć zakup” dostępnej w Aplikacji. W razie problemów z Subskrypcją Użytkownik może skontaktować się przez formularz w Aplikacji lub pod adresem e-mail: support@polylect.pl.
4.3.6. Użytkownik samodzielnie zarządza Subskrypcją Premium (w szczególności jej anulowaniem) w ustawieniach odpowiedniego sklepu (Apple lub Google). Usunięcie Konta w Aplikacji nie powoduje automatycznego anulowania Subskrypcji w sklepie.

5. Powiadomienia push i e-mail

5.1. Aplikacja może proponować Użytkownikowi włączenie powiadomień push. Użytkownik może je zaakceptować lub odrzucić, a także w każdym momencie zmienić ustawienia powiadomień w systemie urządzenia lub w Aplikacji.
5.2. Niezależnie od powiadomień push, Użytkownik może otrzymywać powiadomienia w obrębie Aplikacji (w górnym pasku strony głównej).
5.3. Użytkownik z Kontem może wyrazić zgodę na otrzymywanie treści promocyjnych i newsletterów na adres e-mail. Zgoda jest dobrowolna i może być w każdym momencie wycofana w ustawieniach Aplikacji lub poprzez link rezygnacji.
5.4. Niezależnie od zgody marketingowej, Operator może wysyłać Użytkownikowi wiadomości e-mail związane z funkcjonowaniem Konta i Aplikacji (np. reset hasła, istotne informacje dotyczące bezpieczeństwa lub zmian Regulaminu).

6. Konto, limit urządzeń i usunięcie danych

6.1. Aplikacja może być używana jednocześnie na maksymalnie trzech (3) urządzeniach przypisanych do danego Konta. W przypadku przekroczenia tego limitu Użytkownik może zostać poproszony o wylogowanie się ze wszystkich urządzeń i ponowne zalogowanie na wybranych.
6.2. Użytkownik może w każdej chwili usunąć Konto z poziomu Aplikacji. Usunięcie Konta powoduje usunięcie danych powiązanych bezpośrednio z Kontem, zgodnie z Polityką prywatności.
6.3. Przed usunięciem Konta Użytkownik jest informowany, że:
- utraci dostęp do wszystkich danych powiązanych z Kontem (statystyk, list słówek, historii itp.),
- przypisana do Konta Subskrypcja Premium po stronie Aplikacji przestanie działać,
- Subskrypcję Premium należy osobno anulować w odpowiednim sklepie (Apple / Google), w przeciwnym razie sklep może nadal pobierać opłaty.

7. Zgłaszanie błędów i reklamacje

7.1. Użytkownik może zgłaszać błędy w Treściach (w tym błędy tłumaczeń) oraz problemy techniczne z działaniem Aplikacji:
- za pośrednictwem funkcji zgłoszenia w Aplikacji,
- lub na adres e-mail: support@polylect.pl.
7.2. Reklamacje dotyczące działania Aplikacji można zgłaszać na powyższy adres e-mail z opisem problemu, datą jego wystąpienia oraz – jeśli to możliwe – zrzutem ekranu.
7.3. Reklamacje płatności i Subskrypcji Premium (np. błędne obciążenia, zwroty) należy kierować przede wszystkim do odpowiedniego sklepu (Apple lub Google), zgodnie z jego regulaminem.

8. Zasady niedozwolone i sankcje

8.1. W Aplikacji zabronione jest w szczególności:
- podejmowanie prób oszustwa, obchodzenia lub omijania ograniczeń Aplikacji (np. limitu urządzeń),
- korzystanie z Aplikacji w sposób mogący prowadzić do nadmiernego lub celowego obciążenia serwera,
- próby nieuprawnionego dostępu do systemów lub danych Operatora lub innych Użytkowników,
- umieszczanie lub używanie nazw profilu lub innych treści obraźliwych, wulgarnych, nawołujących do nienawiści, dyskryminacji lub naruszających prawo.
8.2. W przypadku naruszenia postanowień Regulaminu, próby oszustwa lub innego działania niedozwolonego, Operator może:
- tymczasowo zablokować dostęp do Konta,
- całkowicie zablokować Konto,
- podjąć odpowiednie kroki prawne, w tym zgłoszenie sprawy odpowiednim organom.

9. Odpowiedzialność

9.1. Treści udostępniane w Aplikacji mają charakter edukacyjny i poglądowy. Operator dokłada staranności, aby były one poprawne językowo i merytorycznie, jednak nie gwarantuje braku błędów.
9.2. Operator nie ponosi odpowiedzialności za skutki wykorzystania Treści lub tłumaczeń w celach innych niż nauka języków (np. profesjonalne tłumaczenia dokumentów, umów, pism urzędowych), o ile bezwzględnie obowiązujące przepisy prawa nie stanowią inaczej.
9.3. Operator nie ponosi odpowiedzialności za utrudnienia w korzystaniu z Aplikacji wynikające z:
- braku lub niestabilnego połączenia internetowego po stronie Użytkownika,
- awarii lub przerw technicznych po stronie dostawców usług zewnętrznych (np. sklepy z aplikacjami, dostawcy usług tłumaczeniowych),
- działania siły wyższej.
9.4. Operator jest odpowiedzialny wobec konsumentów w zakresie wynikającym z bezwzględnie obowiązujących przepisów prawa (w szczególności prawa konsumenckiego i przepisów o świadczeniu usług drogą elektroniczną).

10. Zmiany Regulaminu

10.1. Operator może zmienić Regulamin z ważnych przyczyn, w szczególności w przypadku:
- zmiany przepisów prawa lub ich wykładni,
- zmiany funkcjonalności Aplikacji,
- konieczności poprawy bezpieczeństwa Użytkowników lub Aplikacji.
10.2. Użytkownicy zostaną poinformowani o zmianach poprzez udostępnienie nowej wersji Regulaminu w Aplikacji oraz wyświetlenie komunikatu z prośbą o akceptację. Dalsze korzystanie z Aplikacji wymaga zaakceptowania nowej wersji Regulaminu.
`;

const PRIVACY_EN_TEXT = `Privacy Policy of the mobile application "Polylect"

1. General information

1.1. This Privacy Policy explains the rules for processing personal data of users of the "Polylect" application.

1.2. The controller of personal data is Michał Pacierz.
Contact details:
- email address: mpacierz@polylect.pl

1.3. For matters related to personal data protection, you can contact the Controller at the above email address.

1.4. Personal data is processed in accordance with applicable law, in particular with Regulation (EU) 2016/679 of the European Parliament and of the Council ("GDPR").

2. Scope of processed data

Depending on how you use the Application, we may process the following categories of data:

2.1. Guest data (without an Account)
- technical data of the device (e.g. device model, operating system, Application identifier),
- anonymous data on the use of the Application (e.g. opened screens, time of use) – if appropriate statistical mechanisms are enabled,
- data contained in error reports (e.g. description of the problem, optionally screenshots if the User provides them).

2.2. Data of a User with an Account
- email address (login to the Account or email address used for Google login),
- profile name (set by the User),
- date of birth (within the range provided by the User),
- statistical data on the use of the Application (e.g. number of texts read, quiz results, word lists),
- data on devices assigned to the Account (for the purpose of verifying the session limit).

2.3. Data of a Premium User
- information about the status of the Premium Subscription (e.g. type of subscription, validity period),
- identifiers required to handle the Subscription, passed between the Application, the store (Apple/Google) and an intermediary service,
- data necessary to operate the "restore purchase" function.
The Controller does not receive full data regarding your payment card or detailed payment information – these are handled by the stores (Apple/Google) and their payment operators.

2.4. Communication and newsletter data
- email address and message content when contacting support@polylect.pl or via the form in the Application,
- information about consents to receive marketing messages or a newsletter,
- data necessary for sending system messages (e.g. password reset, important notices).

3. Purposes and legal bases of data processing

We process personal data for the following purposes and on the following legal bases:

3.1. Use of the Application and provision of services
(Article 6(1)(b) GDPR – necessity for the performance of a contract)
- creation and management of the User Account,
- enabling login (including Google login),
- provision of Content, statistics, word lists, quizzes and other features of the Application,
- handling the Premium Subscription to the extent necessary on the Application side.

3.2. Handling payments and Premium Subscription
(Article 6(1)(b) and (f) GDPR – performance of a contract and legitimate interest)
- verification of the Premium Subscription status,
- handling promotions and promo codes,
- verification of Premium validity on different devices.

3.3. Sending system notifications and contact with the User
(Article 6(1)(b) and (f) GDPR)
- password reset, important changes to the Terms of Use or Privacy Policy,
- responses to error reports and complaints.

3.4. Marketing of own services (newsletter, promotional content)
(Article 6(1)(a) GDPR – consent)
- sending newsletters and promotional information to the email address,
- marketing push notifications (if the User gives consent).

3.5. Statistics, improving the Application and security
(Article 6(1)(f) GDPR – legitimate interest)
- analysis of how the Application is used (in anonymised or pseudonymised form where possible),
- adapting Content and learning level (among others based on age or quiz results),
- monitoring the stability of the Application and preventing abuse (e.g. attempted attacks, excessive server load).

4. Data recipients

4.1. Users’ data may be transferred to the following categories of recipients:
- hosting and server providers (data storage),
- providers handling subscriptions and billing (e.g. Apple App Store, Google Play and a service provider intermediating in subscription handling),
- external login providers (e.g. Google – when logging in with a Google account),
- providers of tools for sending emails or notifications,
- providers of analytics or statistical tools (if used),
- public authorities, if required by law.

4.2. Data is not sold to other entities for the purpose of conducting their own marketing.

4.3. Some data may be processed outside the European Economic Area (e.g. by global IT services). In such cases, the Controller will ensure the use of appropriate legal safeguards, such as standard contractual clauses.

5. Data retention periods

5.1. Data linked to the User Account is stored for the duration of the Account’s existence and subsequently for a period necessary for the consideration of any claims (in principle no longer than 6 years unless the law requires a longer period).

5.2. Guest data stored locally on the device may be deleted upon uninstalling the Application or clearing the Application’s data.

5.3. Data processed on the basis of consent (e.g. marketing) is stored until consent is withdrawn or the newsletter is discontinued, and then for a period necessary for evidential purposes (no longer than 3 years from withdrawal of consent).

5.4. Data from technical logs and statistics may be stored for the period needed to ensure security and improve the functioning of the Application.

6. User’s rights

You have the right to:
- access your personal data,
- rectify data (if it is incorrect),
- erase data,
- restrict processing,
- data portability (where technically feasible),
- object to processing based on legitimate interest,
- withdraw consent at any time (to the extent that processing is based on consent).

To exercise the above rights, contact the Controller at: support@polylect.pl.

You also have the right to lodge a complaint with the competent supervisory authority (the President of the Personal Data Protection Office in Poland) if you believe that the processing of your data infringes GDPR.

7. Account and data deletion

7.1. The User may delete their Account via the appropriate function available in the Application. Deleting the Account results in deletion of data linked to the Account within the Application’s system, subject to data that must be stored for a longer period due to legal requirements (e.g. data necessary for settlements).

7.2. Deleting the Account does not automatically cancel the Premium Subscription in the store. The User must manage the Subscription themselves in the settings of Apple App Store or Google Play.

8. Files and technical identifiers

8.1. The Application may use local files/technical identifiers (equivalents of cookies in the mobile app environment) in order to:
- maintain the User session,
- remember preferences,
- keep anonymous statistics on the use of the Application,
- support offline features.

8.2. In the device settings, the User can limit certain forms of tracking or sharing advertising identifiers, which may affect the way some features of the Application work.

9. Data security

9.1. The Controller uses appropriate technical and organisational measures to protect personal data against unauthorised access, loss, alteration or destruction.

9.2. Access to data is granted only to authorised persons and only to the extent necessary to perform their tasks.

10. Changes to this Privacy Policy

10.1. This Privacy Policy may be updated from time to time, in particular in the event of changes in the law, in the functionality of the Application or in the technologies used.

10.2. Users will be informed of material changes to the Privacy Policy via a notice in the Application and – where possible – by email. Continued use of the Application after the entry into force of the changes means acceptance of the new Privacy Policy.
`;

const TERMS_EN_TEXT = `Terms of Use of the mobile application "Polylect"

1. General provisions

1.1. These Terms of Use set out the rules for using the "Polylect" mobile application available in the Apple App Store and Google Play.

1.2. The owner and administrator of the application is Michał Pacierz, operating as a private individual.
Contact details:
- email address: mpacierz@polylect.pl

1.3. Acceptance of these Terms is voluntary, but necessary to use the application. If you do not accept the Terms, you cannot use the application.

1.4. The current version of the Terms is always available in the application settings. In case of changes to the Terms, the user will be asked to accept them again. Failure to accept the new version means that the user will not be able to continue using the application.

2. Definitions

2.1. User – a natural person using the application (in guest mode or with a created Account).

2.2. Guest – a User using the application without registering an Account.

2.3. Account – an individual User panel created as a result of registration (including via login using a Google account), enabling access to additional features of the Application.

2.4. Premium User – a User with an active Premium subscription purchased via the Apple App Store or Google Play.

2.5. Premium Subscription – paid access to additional content and features of the Application for a period (month, half-year or year), in accordance with the offer presented in the Application and in app stores.

2.6. Content – texts, translations, quizzes, audio materials and other materials available in the Application.

3. Scope and nature of services

3.1. The Application is a language-learning app enabling, in particular:
- access to texts in various languages (including English, German, Spanish, Italian, French, Ukrainian) with translations,
- playback of selected audio content (voice-over),
- use of language quizzes,
- creation of word lists (for Users with an Account),
- viewing learning statistics (for Users with an Account).

3.2. The Application is free to download. Some Content is available free of charge, while access to most Content is only possible under a Premium Subscription.

3.3. Content in the Application is generated and translated by automated tools and then reviewed with respect to:
- absence of violent content,
- absence of sexual content,
- absence of other content commonly considered inappropriate.

3.4. Despite review, Content and translations may contain linguistic, factual or contextual errors. The Application is for educational and illustrative purposes only and must not be treated as a professional source of translations or advice.

4. Modes of using the Application

4.1. Guest mode

4.1.1. The User may use the Application as a Guest after accepting the Terms and the Privacy Policy.

4.1.2. In Guest mode, the following are available, among others:
- browsing selected free Content,
- audio playback for available texts,
- translation of words using Google Translate (by long-pressing a word – where the feature is available),
- the ability to report errors in Content and in the operation of the Application.

4.1.3. In Guest mode, the following are not available:
- learning statistics,
- browsing history of Content,
- creation and storage of word lists,
- Premium Subscription (purchasing Premium requires creating an Account).

4.1.4. Data related to the use of the Application in Guest mode is stored locally on the device and may be lost if the device is changed or the Application is reinstalled.

4.2. User with an Account (without Premium)

4.2.1. The User may create an Account:
- using a standard registration form (login/password),
- via login using a Google account (social login).

4.2.2. After creating an Account, the User may:
- use free Content,
- create word lists,
- mark Content as "favourite" or "liked",
- use basic learning statistics,
- enter promo codes unlocking Premium for a specified period (e.g. one month),
- report errors in Content and in the operation of the Application.

4.2.3. The User may freely set their profile name; however, profile names must not be offensive, vulgar, incite hatred or otherwise violate the law or good morals.

4.2.4. The User provides their date of birth solely for statistical purposes and to adjust the level and nature of future Content.

4.3. Premium User

4.3.1. A User who has an Account may purchase a Premium Subscription for the periods available (e.g. one month, half a year, one year), in accordance with the prices presented in the Application.

4.3.2. The Premium Subscription is purchased via:
- Apple App Store (for Apple devices),
- Google Play (for Android devices).
Billing, payments, refunds and payment-related complaints are handled in accordance with the rules of the respective stores.

4.3.3. A Premium Subscription entitles the User to:
- access all Content marked as premium (including Content added in the future),
- save Content for offline reading, subject to periodic verification of access by the Application (an internet connection is required from time to time).

4.3.4. Additional features such as:
- audio playback (voice-over),
- translation of words via Google Translate,
are supplementary features and their full and uninterrupted operation is not guaranteed. Temporary problems with their operation do not constitute grounds for claims against the Operator beyond the scope arising from mandatory provisions of law.

4.3.5. The User may attempt to restore a Premium Subscription via the "Restore purchase" function available in the Application. In case of problems with the Subscription, the User may contact the Operator via the form in the Application or at: support@polylect.pl.

4.3.6. The User manages the Premium Subscription on their own (in particular its cancellation) in the settings of the respective store (Apple or Google). Deleting the Account in the Application does not automatically cancel the Subscription in the store.

5. Push notifications and email

5.1. The Application may suggest that the User enables push notifications. The User may accept or reject them and may change notification settings at any time in the device system settings or within the Application.

5.2. Regardless of push notifications, the User may receive in-app notifications (in the top bar of the main screen).

5.3. A User with an Account may consent to receiving promotional content and newsletters by email. Consent is voluntary and may be withdrawn at any time in the Application settings or via an unsubscribe link.

5.4. Regardless of marketing consent, the Operator may send the User emails related to the functioning of the Account and the Application (e.g. password reset, important information on security or changes to the Terms).

6. Account, device limit and data deletion

6.1. The Application may be used simultaneously on a maximum of three (3) devices assigned to a given Account. If this limit is exceeded, the User may be asked to log out from all devices and log in again on selected ones.

6.2. The User may delete their Account at any time from within the Application. Deleting the Account results in deletion of data directly related to the Account, in accordance with the Privacy Policy.

6.3. Before deleting the Account, the User is informed that:
- they will lose access to all data related to the Account (statistics, word lists, history, etc.),
- the Premium Subscription associated with the Account on the Application side will cease to function,
- the Premium Subscription must be cancelled separately in the appropriate store (Apple / Google), otherwise the store may continue to charge fees.

7. Error reporting and complaints

7.1. The User may report errors in Content (including translation errors) and technical problems with the Application:
- via the reporting function in the Application,
- or by email to: support@polylect.pl.

7.2. Complaints regarding the functioning of the Application may be submitted to the above email address with a description of the problem, the date of its occurrence and, if possible, a screenshot.

7.3. Complaints about payments and Premium Subscriptions (e.g. incorrect charges, refunds) should be directed primarily to the relevant store (Apple or Google), in accordance with its rules.

8. Prohibited conduct and sanctions

8.1. In the Application, the following is in particular prohibited:
- attempting to cheat, circumvent or bypass Application limitations (e.g. the device limit),
- using the Application in a way that may cause excessive or deliberate server load,
- attempts at unauthorised access to the systems or data of the Operator or other Users,
- placing or using profile names or other content that is offensive, vulgar, incites hatred or discrimination, or violates the law.

8.2. In the event of a breach of these Terms, attempted fraud or other prohibited conduct, the Operator may:
- temporarily block access to the Account,
- permanently block the Account,
- take appropriate legal steps, including reporting the matter to relevant authorities.

9. Liability

9.1. Content made available in the Application is for educational and illustrative purposes. The Operator makes efforts to ensure that it is linguistically and factually correct, but does not guarantee that it is error-free.

9.2. The Operator is not liable for the consequences of using the Content or translations for purposes other than language learning (e.g. professional translation of documents, contracts, official letters), unless mandatory provisions of law state otherwise.

9.3. The Operator is not liable for difficulties in using the Application resulting from:
- lack or instability of the User’s internet connection,
- failures or technical interruptions on the part of external service providers (e.g. app stores, translation service providers),
- force majeure.

9.4. The Operator is liable towards consumers to the extent arising from mandatory provisions of law (in particular consumer law and regulations on the provision of services by electronic means).

10. Changes to the Terms

10.1. The Operator may amend the Terms for important reasons, in particular in the event of:
- changes in the law or its interpretation,
- changes in the functionality of the Application,
- the need to improve the security of Users or the Application.

10.2. Users will be informed about changes by making the new version of the Terms available in the Application and displaying a notice requesting acceptance. Continued use of the Application requires acceptance of the new version of the Terms.
`;


const DOCS: Record<DocType, Record<Locale, StaticDoc>> = {
    PRIVACY: {
        pl: {
            title: "Polityka prywatności",
            version: "1.0",
            publishedAt: "2025-02-05T00:00:00Z",
            text: PRIVACY_PL_TEXT,
        },
        en: {
            title: "Privacy Policy",
            version: "1.0",
            publishedAt: "2025-02-05T00:00:00Z",
            text: PRIVACY_EN_TEXT,
        },
    },
    TERMS: {
        pl: {
            title: "Regulamin korzystania z aplikacji",
            version: "1.0",
            publishedAt: "2025-02-05T00:00:00Z",
            text: TERMS_PL_TEXT,
        },
        en: {
            title: "Terms of Use",
            version: "1.0",
            publishedAt: "2025-02-05T00:00:00Z",
            text: TERMS_EN_TEXT,
        },
    },
};

// function formatDate(iso?: string) {
//     if (!iso) return "";
//     const t = Date.parse(iso);
//     if (!Number.isFinite(t)) return iso;
//     return new Date(t).toLocaleString("pl-PL", {
//         year: "numeric",
//         month: "2-digit",
//         day: "2-digit",
//         hour: "2-digit",
//         minute: "2-digit",
//     });
// }

export default function LegalPublic() {
    const { pathname } = useLocation();

    const docType: DocType = useMemo(() => {
        if (pathname.includes("polityka-prywatnosci")) return "PRIVACY";
        return "TERMS";
    }, [pathname]);

    const locale: Locale = useMemo(() => {
        if (pathname.endsWith("/en")) return "en";
        return "pl";
    }, [pathname]);

    const doc = DOCS[docType][locale];

    const pageTitle = doc.title;
    const otherHref = docType === "PRIVACY" ? "/regulamin" : "/polityka-prywatnosci";
    const otherLabel = docType === "PRIVACY" ? "Zobacz Regulamin" : "Zobacz Politykę prywatności";

    const toggleLangHref =
        locale === "pl"
            ? pathname.endsWith("/en")
                ? pathname
                : `${pathname.replace(/\/$/, "")}/en`
            : pathname.replace(/\/en$/, "") || "/";

    const toggleLangLabel = locale === "pl" ? "EN" : "PL";

    return (
        <div style={styles.page}>
            <div style={styles.shell}>
                <header style={styles.header}>
                    <div style={styles.titleBlock}>
                        <div style={styles.kicker}>Dokumenty prawne</div>
                        <h1 style={styles.h1}>{pageTitle}</h1>
                    </div>

                    <div style={styles.headerRight}>
                        <Link to={otherHref} style={styles.switchBtn}>
                            {otherLabel}
                        </Link>
                        <Link to={toggleLangHref} style={styles.langBtn}>
                            {toggleLangLabel}
                        </Link>
                    </div>
                </header>

                <div style={styles.card}>
                    <div style={styles.metaRow}>
                        {/* {doc.version && (
                            <div style={styles.metaItem}>
                                <span style={styles.metaKey}>Wersja</span>
                                <span style={styles.metaVal}>{doc.version}</span>
                            </div>
                        )} */}
                        {/* {doc.publishedAt && (
                            <div style={styles.metaItem}>
                                <span style={styles.metaKey}>Opublikowano</span>
                                <span style={styles.metaVal}>{formatDate(doc.publishedAt)}</span>
                            </div>
                        )} */}
                        <div style={styles.metaItem}>
                            <span style={styles.metaKey}>Język: </span>
                            <span style={styles.metaVal}>{locale === "pl" ? "Polski" : "English"}</span>
                        </div>
                    </div>

                    <div style={styles.divider} />

                    {locale === "en" && (
                        <div style={styles.notice}>
                            <div style={styles.noticeTitle}>Important</div>
                            <div style={styles.noticeText}>
                                The legally binding version of this document is the Polish version.
                                This English version is provided for convenience and informational purposes only.
                            </div>
                        </div>
                    )}

                    <pre style={styles.pre}>{doc.text}</pre>
                </div>

                <footer style={styles.footer}>
                    <span style={styles.footerText}>PolyLect {new Date().getFullYear()}</span>
                </footer>
            </div>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    page: {
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        padding: 24,
        background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 70%)",
        color: "#0f172a",
    },
    shell: {
        width: "100%",
        maxWidth: 980,
    },
    header: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
        marginBottom: 14,
    },
    titleBlock: {
        display: "grid",
        gap: 6,
    },
    headerRight: {
        display: "flex",
        gap: 8,
        alignItems: "center",
    },
    kicker: {
        fontSize: 12,
        fontWeight: 300,
        letterSpacing: ".08em",
        textTransform: "uppercase",
        color: "#64748b",
    },
    h1: {
        margin: 0,
        fontSize: 24,
        lineHeight: 1.15,
        letterSpacing: "-0.01em",
    },
    switchBtn: {
        textDecoration: "none",
        fontWeight: 500,
        fontSize: 13,
        padding: "10px 12px",
        borderRadius: 12,
        background: "#ffffff",
        color: "#0f172a",
        border: "1px solid rgba(15, 23, 42, 0.12)",
        boxShadow: "0 1px 0 rgba(15, 23, 42, 0.04)",
    },
    langBtn: {
        textDecoration: "none",
        fontWeight: 500,
        fontSize: 12,
        padding: "8px 10px",
        borderRadius: 999,
        background: "#0f172a",
        color: "#f9fafb",
        border: "1px solid rgba(15, 23, 42, 0.2)",
    },
    card: {
        background: "rgba(255,255,255,0.92)",
        border: "1px solid rgba(15, 23, 42, 0.1)",
        borderRadius: 18,
        padding: 18,
        boxShadow: "0 18px 40px rgba(15, 23, 42, 0.08)",
        backdropFilter: "blur(8px)",
    },
    metaRow: {
        display: "flex",
        gap: 10,
        flexWrap: "wrap",
        alignItems: "center",
        minHeight: 26,
    },
    metaItem: {
        display: "inline-flex",
        alignItems: "baseline",
        gap: 8,
        padding: "6px 10px",
        borderRadius: 999,
        background: "#f8fafc",
        border: "1px solid rgba(15, 23, 42, 0.08)",
        fontSize: 13,
    },
    metaKey: { fontWeight: 600, color: "#334155" },
    metaVal: { fontWeight: 400, color: "#0f172a" },
    divider: {
        margin: "14px 0",
        height: 1,
        background: "rgba(15, 23, 42, 0.08)",
    },
    notice: {
        border: "1px solid rgba(234, 179, 8, 0.4)",
        background: "rgba(254, 249, 195, 0.8)",
        borderRadius: 14,
        padding: 12,
        marginBottom: 12,
    },
    noticeTitle: { fontWeight: 700, marginBottom: 4, color: "#854d0e" },
    noticeText: { color: "#854d0e", fontSize: 13.5 },
    pre: {
        whiteSpace: "pre-wrap",
        fontSize: 14,
        lineHeight: 1.75,
        margin: 0,
        background: "#f8fafc",
        border: "1px solid rgba(15, 23, 42, 0.08)",
        borderRadius: 14,
        padding: 14,
        color: "#0f172a",
    },
    footer: {
        marginTop: 14,
        display: "flex",
        justifyContent: "center",
        opacity: 0.75,
        fontSize: 12,
        color: "#64748b",
    },
    footerText: {
        padding: "8px 12px",
        borderRadius: 999,
        border: "1px solid rgba(15, 23, 42, 0.08)",
        background: "rgba(255,255,255,0.7)",
    },
};
